import React, { useState, useRef } from 'react';
import { View, TouchableOpacity, Modal, Text, StyleSheet } from 'react-native';
import { ColorPicker } from 'react-native-color-picker';
import Slider from '@react-native-community/slider';
import Swal  from 'sweetalert2';

const CustomColorPicker = ({
  initialColor = 'blue',
  onColorChange,
  style,
  disabled = false,
  size = { width: 40, height: 40 }
}) => {
  const [isPickerVisible, setIsPickerVisible] = useState(false);
  const [selectedColor, setSelectedColor] = useState(initialColor);
  const colorPickerRef = useRef(null);

  const handleConfirm = async () => {
    if (colorPickerRef.current) {
      const color = await colorPickerRef.current.getColor();
      setSelectedColor(color);
      if (onColorChange) {
        onColorChange(color);
      }
    }
    setIsPickerVisible(false);
  };

  const handleColorSelect = (color) => {
    setSelectedColor(color);
  };

  const closePicker = () => {
    setIsPickerVisible(false);

  };

  return (
    <>
      <TouchableOpacity
        style={[
          styles.colorBox,
          { backgroundColor: selectedColor, ...size },
          style,
          disabled && styles.disabled
        ]}
        onPress={() => !disabled && setIsPickerVisible(true)}
        disabled={disabled}
      >
      </TouchableOpacity>
      <Modal
        visible={isPickerVisible}
        transparent={true}
        animationType='slide'
        onRequestClose={closePicker}
      >
        <View style={styles.modalContainer}>
          <View style={styles.pickerContainer}>
            <Text style={styles.title}>Select Color</Text>
            <Text style={styles.buttonText}>Drag the small circle to change colour.</Text>
            <ColorPicker
              ref={colorPickerRef}
              onColorSelected={() => {}}
              style={styles.colorPicker}
              defaultColor={selectedColor}
              sliderComponent={Slider}
            />
            <View style={styles.buttonContainer}>
              <TouchableOpacity
                style={[styles.button, styles.cancelButton]}
                onPress={() => setIsPickerVisible(false)}
              >
                <Text style={styles.buttonText}>Cancel</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[styles.button, styles.confirmButton]}
                onPress={handleConfirm}
              >
                <Text style={styles.buttonText}>Done</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
    </>
  );
};

const styles = StyleSheet.create({
  colorBox: {
    width: 40,
    height: 40,
    borderRadius: 8,
    borderWidth: 0,
    borderColor: '#ddd',
    justifyContent: 'center',
    alignItems: 'center',
  },
  disabled: {
    opacity: 0.5,
  },
  modalContainer: {
    flex: 1,
    backgroundColor: 'white',
    justifyContent: 'center',
    alignItems: 'center',
  },
  pickerContainer: {
    backgroundColor: 'white',
    borderRadius: 15,
    padding: 20,
    width: '90%',
    maxWidth: 350,
    elevation: 5,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 20,
    color: 'black',
  },
  colorPicker: {
    height: 200,
    marginBottom: 20,
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 10,
  },
  button: {
    flex: 1,
    paddingVertical: 12,
    borderRadius: 8,
    alignItems: 'center',
  },
  cancelButton: {
    backgroundColor: '#f0f0f0'
  },
  confirmButton: {
    backgroundColor: '#86BC25',
  },
  buttonText: {
    fontSize: 16,
    fontWeight: '600',
  },
});

export default CustomColorPicker;